// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.isolated-scroll-container[data-v-6d9a995a]{position:relative}.inner-scroll-content[data-v-6d9a995a]{position:absolute;inset:0;overflow:auto}`, "",{"version":3,"sources":["webpack://./client/components/IsolatedScrollContainer.vue"],"names":[],"mappings":"AAGA,4CACE,iBAAA,CAGF,uCACE,iBAAA,CACA,OAAA,CACA,aAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
